/**
 * useReturnToBot (KAN-686): give a client handed to a manager back to the bot.
 *
 * POST /clients/{id}/return-to-bot/ removes needs_human, moves the stage back
 * and switches manual mode off. Afterwards the client card, the clients list,
 * the lead card and the client's transcript are refreshed.
 */
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { clientsApi } from '@/services/api/clients';
import {
  clientLeadCardQueryKey,
  clientQueryKey,
} from '@/services/api/clientQueries';
import { extractErrorMessage } from '@/lib/extractErrorMessage';
import { transcriptQueryKey } from './useTranscriptMessages';

export function useReturnToBot(clientId: string | null) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => clientsApi.returnToBot(clientId as string),
    onSuccess: () => {
      toast.success('Клиент возвращён боту');
    },
    onError: (err) => {
      toast.error(extractErrorMessage(err, 'Не удалось вернуть клиента боту'));
    },
    onSettled: () => {
      void queryClient.invalidateQueries({ queryKey: clientQueryKey(clientId) });
      void queryClient.invalidateQueries({ queryKey: ['clients'] });
      void queryClient.invalidateQueries({
        queryKey: clientLeadCardQueryKey(clientId),
      });
      void queryClient.invalidateQueries({
        queryKey: transcriptQueryKey(clientId, null),
      });
    },
  });
}
